import { describeFields, FieldWidget } from '../common/fields';
import { StaffSchema } from './schemas';

export const STAFF_FIELDS = describeFields(StaffSchema, {
  staffId: {},
  groups: {},
  firstName: {},
  lastName: {},
  birthday: { widget: FieldWidget.Date },
  email: {},
  phoneNumber: {},
  orgStaffId: {},
  disabled: { widget: FieldWidget.Text },
  profileIcon: {},
  slackId: {},
  settings: {},
});
